export default "__VITE_ASSET__BNqm9XxD__"